import DirectInput from '../../../../components/directInput/DirectInput';
import handleTextChange from '../../../../utils/handleTextChange';

export default function GoogleRating({ formData, setFormData, accRe, setAccRe }) {
    return (
        <div>
            <h2 className='orgRegisterH2'>Google Ratings</h2>
            <div className='orgRegisterSecDiv'>
                <DirectInput
                    label='Google Rating'
                    name={'googleRating'}
                    value={formData.googleRating}
                    type='number'
                    placeholder='google rating'
                    setFormData={setFormData}
                    min={1}
                    limit={1}
                    minimum={1}
                    max={5}
                />
                <DirectInput
                    label='Rating Count'
                    name={'googleRaCount'}
                    value={formData.googleRaCount}
                    type='number'
                    placeholder='Rating Count'
                    setFormData={setFormData}
                    min={1}
                    limit={1}
                    minimum={1}
                    max={5}
                />
            </div>
        </div>
    );
}
